export const ATTENDANTLIST_STATUS = 'ATTENDANTLIST_STATUS';